import { type MenuItem } from 'shared/types'

export function sortMenuByPriority(arr: MenuItem[]) {
  return arr.sort((a, b) => a.order - b.order)
}
